export default "__VITE_ASSET__sdLquN6T__"